import { navigateToSelectedChannelRoute, navigateToVideoCallList } from 'utils/history';
import PostcardImage from 'assets/category_cards/communicate/postcard.png';
import { FormattedMessage } from 'react-intl';
import { useSelectedLinkContext } from 'contexts';
import Route from 'routes/Routes';
import MenuGridPageLayout, {MenuCategory} from 'layouts/MenuGridPageLayout';
import VideoCallCategory from './VideoCallCategory';

const Communicate = (): JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();

  const handleVideoCallClick = () => navigateToVideoCallList(selectedLink);

  const handlePostcardClick = () => navigateToSelectedChannelRoute(selectedLink, Route.POSTCARD);

  return (
    <MenuGridPageLayout title={<FormattedMessage id="category.communicate.description" />}>
      <VideoCallCategory handleVideoCallClick={handleVideoCallClick} />
      <MenuCategory
        altId='category.communicate.subcategory.postcard'
        image={PostcardImage}
        md={6}
        onClick={handlePostcardClick}
      />
    </MenuGridPageLayout>
  );
};

export default Communicate;
